<template>
  <v-row no-gutters>
    <v-col class="align-self-end" cols="7" style="cursor: pointer">
      <img
        id="header_logo"
        class="logo"
        :src="isSerasa
        ? currentBaseUrl + '/img/clear_serasa.svg'
        : '/img/clearsale_part_serasa.svg'"
        :alt="altText"
        @click="redirectToHome"
      />
    </v-col>
    <v-col class="text-right align-self-end" cols="5">
      <div class="d-flex justify-end">
        <div
          v-if="app === 'primeiroAcesso'"
          class="d-flex align-end mr-6 text-center"
        >
          <a id="header_link_suporte" class="text-menu-feature" href="/">
            <p>Fazer login</p>
          </a>
        </div>
        <div
          v-if="app !== 'login' && app !== 'primeiroAcesso'"
          class="d-flex align-end ml-2 text-center"
        >
          <p
            id="header_link_suporte"
            class="text-menu-feature"
            @click="$router.push('/')"
          >
            Fazer login
          </p>
        </div>
        <div
          v-if="
            app === 'portal' &&
            oidcIsAuthenticated &&
            oidcAuthenticationIsChecked
          "
          class="flex-grow-1 ml-2 text-center"
        >
          <a
            id="header_link_sair"
            class="d-flex align-end text-menu-feature feedback-error--text"
            href="#"
            @click.prevent.stop="signOutOidc"
          >
            <strong>Sair</strong>
          </a>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    app: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapGetters(["oidcIsAuthenticated", "oidcAuthenticationIsChecked", "isSerasa", 'currentBaseUrl']),
    altText() {
      return this.themeSerasa
        ? "Clearsale a part of Serasa Experian"
        : "Logo da ClearSale"
    },     
  },
  methods: {
    ...mapActions(["signOutOidc", "signOutOidcSilent"]),
    redirectToHome() {
      const path = "/";
      if (this.$route.path !== path) this.$router.push(path);
    },
  },
};
</script>

<style scoped>
#header_link_suporte {
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
  color: var(--v-brand-primary-base);
}
</style>
